import { render } from "./addSpecificData.vue?vue&type=template&id=7dfe7223&scoped=true"
import script from "./addSpecificData.vue?vue&type=script&lang=js"
export * from "./addSpecificData.vue?vue&type=script&lang=js"

import "./addSpecificData.vue?vue&type=style&index=0&id=7dfe7223&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfe7223"]])

export default __exports__